import React from "react";
import PropTypes from "prop-types";
import Notes from './price_combined/Notes';
import PriceMatrix from './price_combined/PriceMatrix';

const PriceCombined = (props) => {
  const {
    usCombined, quoteStep, onPriceSelect, parametersChanged, parameters,
  } = props;
  return (
    <div className="card-body price-combined">
      <h2 className="price-matrix-title">Selected Specs</h2>
      <Notes />
      <PriceMatrix
        usCombined={usCombined}
        quoteStep={quoteStep}
        onPriceSelect={onPriceSelect}
        parametersChanged={parametersChanged}
        parameters={parameters} />
    </div>
  )
};

PriceCombined.propTypes = {
  usCombined: PropTypes.object.isRequired,
  quoteStep: PropTypes.string.isRequired,
  onPriceSelect: PropTypes.func.isRequired,
  parametersChanged: PropTypes.bool.isRequired,
  parameters: PropTypes.object.isRequired,
}

export default PriceCombined;
